// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1bUfJ","colCheckbox":"styles_colCheckbox__fPDj4"};